import ContentLoader from 'react-content-loader';

interface Props {
    height: number;
    radius?: number;
    width?: number;
}

const LoaderElement = ({ height, radius = 16, width }: Props): JSX.Element => (
    <ContentLoader
        speed={3}
        interval={0}
        width={width ? width : '100%'}
        height={height}
        backgroundColor="#e1e1e1"
        foregroundColor="#f0f0f0"
    >
        <rect x="0" y="0" rx={radius} width="100%" height={height} />
    </ContentLoader>
);

export default LoaderElement;
